// extracted by mini-css-extract-plugin
module.exports = {"remove":"DomainForm_remove__2dk1k","notification":"DomainForm_notification__mAIBt"};